module.exports = __webpack_public_path__ + "static/media/aline-goncalvez.19b10220.jpeg";